module.exports = __webpack_public_path__ + "static/img/13.ea38581.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/zh/13.png
// module id = M2G9
// module chunks = 0